import { ComponentPropsWithoutRef, useCallback, useState } from 'react';

import WaveUIProgressDialog from '../components/dialogs/WaveUIProgressDialog';

type ProgressDialog = Omit<
  ComponentPropsWithoutRef<typeof WaveUIProgressDialog>,
  'onClose'
>;

const useProgressDialog = () => {
  const [progressDialog, setProgressDialog] = useState<ProgressDialog>({
    title: '',
    open: false,
    progress: 0,
  });

  const onUpdateProgressDialog = useCallback(
    (state: Partial<ProgressDialog>) => {
      setProgressDialog((prev) => ({
        ...prev,
        ...state,
      }));
    },
    [setProgressDialog],
  );

  return { progressDialog, onUpdateProgressDialog };
};

export default useProgressDialog;
